// Appointment timestamps arrive as UTC/ISO strings; everything here renders in the viewer's local zone.

function toDate(value) {
    if (!value) return null;
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatAppointmentWindow(startAt, endAt) {
    const start = toDate(startAt);
    const end = toDate(endAt);

    if (!start) {
        return { date: "—", time: "—", timeZone: "" };
    }

    const date = new Intl.DateTimeFormat(undefined, {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric",
    }).format(start);

    const timeFormatter = new Intl.DateTimeFormat(undefined, {
        hour: "numeric",
        minute: "2-digit",
    });

    const time = end
        ? `${timeFormatter.format(start)} – ${timeFormatter.format(end)}`
        : timeFormatter.format(start);

    const timeZone = new Intl.DateTimeFormat(undefined, {
        timeZoneName: "short",
    })
        .formatToParts(start)
        .find((part) => part.type === "timeZoneName")?.value ?? "";

    return { date, time, timeZone };
}

export function formatCustomerName(customerInfo) {
    const name = [customerInfo?.first_name, customerInfo?.last_name]
        .filter(Boolean)
        .join(" ")
        .trim();

    return name || "—";
}

export function formatStatusLabel(status) {
    if (!status) return "Unknown";
    return String(status)
        .replace(/[_-]+/g, " ")
        .replace(/\b\w/g, (character) => character.toUpperCase());
}

export function statusTone(status) {
    const normalized = String(status || "").toLowerCase();

    if (["paid", "succeeded", "success", "confirmed", "completed", "active"].includes(normalized)) {
        return "success";
    }
    if (["pending", "processing", "requires_action", "awaiting_deposit", "scheduled"].includes(normalized)) {
        return "warning";
    }
    if (["failed", "canceled", "cancelled", "declined", "expired", "refunded"].includes(normalized)) {
        return "danger";
    }
    return "neutral";
}
